import BlogGridView from "../../../commonComponents/blogGridView";

const BlogToSliderContainer = () => {
  return <BlogGridView type="top_slider" gridSize={3} />;
};

export default BlogToSliderContainer;
